// extracted by mini-css-extract-plugin
module.exports = {"logoText":"Logo_logoText__3BCvz"};